function createInnerLine(ctx, radius = 1) {
    ctx.beginPath();
    const innerRadius = radius * 0.8;
    ctx.arc(0, 0, innerRadius, 0.8 * Math.PI, 0.2 * Math.PI);
    const grad0 = ctx.createLinearGradient(114.984, 0.379698, 114.98, 180);
    grad0.addColorStop(0, 'rgba(177, 138, 75, 0.7)');
    grad0.addColorStop(0.5, 'rgba(177, 138, 75, 0.5)');
    grad0.addColorStop(1, 'rgba(177, 138, 75, 0.1)');
    ctx.strokeStyle = grad0;
    ctx.lineWidth = 1;
    ctx.stroke();
}

function createDefaultLine(ctx, radius, strokeWidth, defaultColor) {
    ctx.beginPath();
    ctx.arc(0, 0, radius, 0.8 * Math.PI, 0.2 * Math.PI);
    // ctx.arc(0, 0, radius, 0, 2*Math.PI);
    ctx.strokeStyle = defaultColor;
    ctx.lineWidth = strokeWidth || radius * 0.217;
    ctx.lineCap = 'round';
    ctx.stroke();
}

function createProgressLine(ctx, percent, radius, strokeWidth, progressColor) {
    ctx.beginPath();
    const normalizedPercent = percent < 0 ? 0 : percent > 100 ? 100 : percent;
    const start = 0.8 * Math.PI;
    const end = 0.8 * Math.PI + (1.4 * Math.PI * normalizedPercent) / 100;
    if (start === end) return;
    ctx.arc(0, 0, radius, start, end);
    if (typeof progressColor === 'object') {
        const grad = ctx.createLinearGradient(0, 200, 280, 110);
        grad.addColorStop(0, progressColor[0]);
        grad.addColorStop(1, progressColor[1]);
        ctx.strokeStyle = grad;
    } else {
        ctx.strokeStyle = progressColor;
    }
    ctx.lineWidth = strokeWidth || radius * 0.217;
    ctx.lineCap = 'round';
    ctx.stroke();
}

function createLine(ctx, radius, config) {
    const { strokeWidth, defaultColor, progressColor, percent } = config;

    createInnerLine(ctx, radius);
    createDefaultLine(ctx, radius, strokeWidth, defaultColor);
    createProgressLine(ctx, percent, radius, strokeWidth, progressColor);
}

export const createCanvas = (config) => {
    const { id, strokeWidth } = config;
    const canvas = document.getElementById(id);
    const canvasWrapper = document.getElementById(`${id}Wrapper`);
    const ctx = canvas.getContext('2d');

    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    const canvasWrapperProps = canvasWrapper?.getBoundingClientRect();

    ctx.canvas.width = canvasWrapperProps?.width;
    ctx.canvas.height = canvasWrapperProps?.width;

    let radius = canvas?.width / 2 - strokeWidth / 2;
    ctx.translate(canvas?.width / 2, canvas?.height / 2);

    createLine(ctx, radius, config);
};
